<template>
  <my-modal
    :title="title"
    :visible="visible"
    :centered="true"
    :footer="false"
  >
    <div slot="content">
      <!-- <h3></h3> -->
      <ul>
        <li
          v-for="item in data"
          :key="item.fieldkey"
        >
          <span v-if="item.matchtype === 1">{{ tips2[0] }}{{ item.fieldname }} <i class="fs-warning">{{ item.fieldvalue }}</i> {{ tips2[1] }}</span>
          <span v-else-if="item.matchtype === 2">{{ tips1[0] }}{{ item.fieldname }}{{ tips1[1] }} <i class="fs-warning">{{ item.fieldvalue }}</i> {{ tips1[2] }}</span>
        </li>
      </ul>

      <cube-form-group class="cube-picker-footer footer">
        <cube-button
          type="reset"
          class="cancel-btn"
          @click="handleCancel"
        >
          {{ $t('message["287"]') }}
        </cube-button>
        <cube-button
          v-if="data[0] && data[0].isrepeatsave"
          type="submit"
          class="confirm-btn"
          @click="handleOk"
        >
          {{ $t('message["467"]') }}
        </cube-button>
      </cube-form-group>
    </div>
  </my-modal>
</template>

<script>
import MyModal from '@/components/mobile/Modal'

export default {
  components: {
    MyModal
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default: () => []
    },
    saveType: {
      type: String,
      default: ''
    },
    againSaveForm: {
      type: Function,
      default: () => { }
    }
  },
  data () {
    return {
      title: `<i class="
        iconfont
        iconicon-test68"
      />${this.$t('message["1617"]')}！`
    }
  },
  computed: {
    tips1 () {
      return this.$t('message["1453"]').split('|')
    },
    tips2 () {
      return this.$t('message["1454"]').split('|')
    }
  },
  methods: {
    hide () {
      this.$emit('update:visible', false)
    },
    async handleOk () {
      let checkrepeatconfirm = 1
      await this.againSaveForm({ saveType: this.saveType, checkrepeatconfirm })
      this.hide()
    },
    handleCancel () {
      this.hide()
    }
  }
}
</script>

<style lang="scss" scoped>
h3.title {
  margin-bottom: 20px;
  font-weight: bold;
}
::v-deep .ant-checkbox-wrapper {
  margin-bottom: 25px;
}
::v-deep .cube-picker-panel {
  width: 270px;
  height: auto;
}
::v-deep .ant-form-item-label {
  display: none;
}
li {
  margin-bottom: 10px;
  line-height: 1.2;
  padding: 0 20px;
  .fs-warning {
    font-style: normal;
    word-break: break-all;
  }
  .look-repeat-btn {
    margin-left: 16px;
  }
}
.cube-picker-footer ::v-deep {
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
  height: 50px;
  line-height: 50px;
  border-top: solid 1px #dbdbdb;
  .cube-form-group-content {
    display: flex;
    flex: 1;
    justify-content: space-between;
  }
  .cube-btn {
    padding: 0;
    color: $gray2;
    background-color: #fff;
    border-radius: 0;
    &:first-child {
      border-right: solid 1px #dbdbdb;
    }
    &.confirm-btn {
      color: $primary-color;
    }
  }
}
</style>
